(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CityService', CityService)

    /** @ngInject */
    function CityService(HttpService) {
        const CityService = {
            getByState: getByState
        }

        return CityService;

        function getByState(stateId) {
            return HttpService.get(`/states/${stateId}/cities`);
        }
    }
}());